import { ENVIDE } from "env.config";
import { getApiGatewayClient } from "services/api";

// Host Admin
const getHostList = async () => {
  return fetch("/42QConfig/mes15host.json")
    .then((res) => res.json())
    .then((res) => {
      if (res.Items && res.Items.length) {
        return res.Items.map((item) => {
          item.HostId = item.Host;
          return item;
        });
      }
      return [];
    })
    .catch(() => Promise.resolve([]));
};

const getMES16HostList = async () => {
  const params = {
    operation: "list",
    tableName: "DevPortalClientHost",
    payload: {},
  };
  return getApiGatewayClient("/admin/developer", params).then((res) => {
    if (res.success) {
      return res.Items;
    }
    return [];
  });
};

const addHost = async (data) => {
  const { HostId, Host, Scope, Stage, Name, Envide } = data;
  const params = {
    operation: "createHost",
    tableName: "DevPortalClientHost",
    payload: {
      Item: {
        MES: "MES16",
        HostId,
        Scope,
        Stage,
        Host,
        Envide,
        Name,
      },
    },
  };
  return getApiGatewayClient("/admin/developer", params);
};

const updateHost = async (data) => {
  const { HostId, Name, Host } = data;
  let params = {
    operation: "updateHost",
    tableName: "DevPortalClientHost",
    payload: {
      Key: {
        HostId,
      },
      AttributeUpdates: {
        Name: {
          Action: "PUT",
          Value: Name,
        },
        // required for server side verification
        Host: {
          Action: "PUT",
          Value: Host,
        },
      },
    },
  };
  return getApiGatewayClient("/admin/developer", params);
};

const deleteHost = async (data) => {
  const { HostId, Host } = data;
  const params = {
    operation: "deleteHost",
    tableName: "DevPortalClientHost",
    payload: {
      Key: {
        HostId,
        Host,
      },
    },
  };
  return getApiGatewayClient("/admin/developer", params);
};

// developer information page
// app
const getProfileList = async ({ host, filter, Scope, Stage, MES }) => {
  const payload = {
    Host: host || "",
    Filter: filter || "",
    Scope: Scope || "",
    Stage: Stage || "",
    MES: MES || "",
  };
  const params = {
    operation: "getProfileWithoutPermission",
    tableName: "DevPortalClientProfile",
    payload,
  };
  return getApiGatewayClient("/admin/developer", params).then((res) => {
    if (res.success) {
      return res.Items;
    }
    return [];
  });
};
const getAppDetail = async (data) => {
  const params = {
    operation: "readApp",
    tableName: "DevPortalClientApp",
    payload: {
      Key: {
        UserName: data.UserName,
      },
    },
  };

  return getApiGatewayClient("/admin/developer", params).then((res) => {
    if (res.success) {
      if (res.Item && res.Item.AppId) {
        return res.Item;
      } else {
        return {};
      }
    } else {
      return null;
    }
  });
};

const getApiKeyValue = async (data) => {
  const params = {
    operation: "getApiKeys",
    tableName: "DevPortalClientApp",
    payload: {
      Key: {
        IdentityId: data,
      },
    },
  };

  return getApiGatewayClient("/admin/developer", params).then((res) => {
    if (res.success) {
      if (res.value) {
        return res.value;
      }
      return "";
    }
    return "";
  });
};

const validateAttachedHost = async (data) => {
  const { appName, clientId, oauthScope, addUsagePlanId, apiKey, userName } =
    data;
  const params = {
    operation: "validateAttachedHost",
    tableName: "DevPortalClientApp",
    payload: {
      appName,
      clientId,
      oauthScope,
      addUsagePlanId,
      userName,
      apiKey,
    },
  };
  return getApiGatewayClient("/admin/developer", params);
};

const updateApp = async (data) => {
  const {
    operation,
    appName,
    clientId,
    oauthScope,
    addUsagePlanId,
    apiKey,
    userName,
  } = data;
  const params = {
    operation,
    tableName: "DevPortalClientApp",
    payload: {
      appName,
      clientId,
      oauthScope,
      addUsagePlanId,
      userName,
      apiKey,
    },
  };
  return getApiGatewayClient("/admin/developer", params);
};

const addApp = async (data) => {
  const { operation, appName, oauthScope, userName, addUsagePlanId, apiKey } =
    data;
  const params = {
    operation: operation,
    tableName: "DevPortalClientApp",
    payload: {
      apiKey,
      appName,
      oauthScope,
      userName: userName,
      addUsagePlanId,
    },
  };
  return getApiGatewayClient("/admin/developer", params);
};

const deleteApp = (data) => {
  const { operation, clientId, userName, apiKey } = data;
  const params = {
    operation,
    tableName: "DevPortalClientApp",
    payload: {
      apiKey,
      clientId,
      userName,
    },
  };
  return getApiGatewayClient("/admin/developer", params);
};

const getClientSecret = (data) => {
  const params = {
    operation: "querySecret",
    tableName: "DevPortalClientApp",
    payload: {
      Key: {
        UserName: data.UserName,
      },
    },
  };
  return getApiGatewayClient("/admin/developer", params);
};

const updateAppProfile = (data) => {
  const { userName, profile } = data;
  const params = {
    operation: "updateAppProfile",
    tableName: "DevPortalClientApp",
    payload: {
      Key: {
        UserName: userName,
      },
      AttributeUpdates: {
        Profile: {
          Action: "PUT",
          Value: profile,
        },
      },
    },
  };
  return getApiGatewayClient("/admin/developer", params);
};
const getTargetList = () => {
  const params = {
    operation: "list",
    tableName: "DevPortalClientTargets",
    payload: {},
  };
  return getApiGatewayClient("/admin/developer", params).then((res) => {
    if (res.success) {
      return res.Items;
    }
    return [];
  });
};
const updateTarget = (data) => {
  const { AppId, Environment, Target, UserName } = data;
  const params = {
    operation: "updateTarget",
    tableName: "DevPortalClientTargets",
    payload: {
      UserName,
      Key: {
        AppId,
        Environment,
      },
      AttributeUpdates: {
        Target: {
          Action: "PUT",
          Value: Target,
        },
      },
    },
  };
  return getApiGatewayClient("/admin/developer", params);
};
// host
const getAppHostList = async (data) => {
  const params = {
    operation: "read",
    tableName: "DevPortalClientMES16App",
    payload: {
      Key: {
        UserName: data.UserName,
      },
    },
  };
  return getApiGatewayClient("/admin/developer", params).then((res) => {
    if (res.success) {
      if (res.Item && res.Item.Host) {
        return res.Item.Host;
      }
    }
    return [];
  });
};

const getMES16AppHostList = async (data) => {
  const params = {
    operation: "getMES16HostList",
    tableName: "DevPortalClientMES16App",
    payload: {
      Key: {
        UserName: data.UserName,
      },
    },
  };
  return getApiGatewayClient("/admin/developer", params).then(
    (res) => res.Items
  );
};

const addAppHost = async (data) => {
  const { UserName, Host, Scope, Stage, Target, Profile, AddUsagePlanId, ApiKey } = data;
  const params = {
    operation: "addAppHost",
    tableName: "DevPortalClientMES16App",
    payload: {
      Key: {
        UserName,
      },
      AttributeUpdates: {
        Host: {
          Action: "PUT",
          Value: {
            Host,
            Scope,
            Stage,
            Profile,
            Target,
          },
        },
        AddUsagePlanId,
        ApiKey
      },
    },
  };
  return getApiGatewayClient("/admin/developer", params);
};

const updateAppHost = async (data) => {
  const { Host, Scope, Stage, Target, Profile, UserName } = data;
  const params = {
    operation: "updateAppHost",
    tableName: "DevPortalClientMES16App",
    payload: {
      Key: {
        UserName,
      },
      AttributeUpdates: {
        Host: {
          Action: "PUT",
          Value: {
            Host,
            Scope,
            Stage,
            Profile,
            Target,
          },
        },
      },
    },
  };
  return getApiGatewayClient("/admin/developer", params);
};

const deleteAppHost = async (data) => {
  const { UserName, Host } = data;
  const params = {
    operation: "deleteAppHost",
    tableName: "DevPortalClientMES16App",
    payload: {
      Key: {
        UserName,
      },
      AttributeUpdates: {
        Host: {
          Action: "PUT",
          Value: {
            ...Host,
          },
        },
      },
    },
  };
  return getApiGatewayClient("/admin/developer", params);
};

// APIs page

const getApiList = async (data) => {
  const params = {
    operation: "getApisGroupByHost",
    tableName: "DevPortalClientApi",
    payload: {
      isAdmin: data.admin,
      envideConfig: data.envideConfig,
    },
  };
  return getApiGatewayClient("/developer", params).then((res) => {
    if (res.success) {
      return res.Items;
    }
    return [];
  });
};

// Dashboard page
const getUserClientSecret = async () => {
  const params = {
    operation: "querySecret",
    tableName: "DevPortalClientApp",
    payload: {},
  };
  return getApiGatewayClient("/developer", params);
};

const getUserAppDetail = async () => {
  const params = {
    operation: "readApp",
    tableName: "DevPortalClientApp",
    payload: {},
  };
  return getApiGatewayClient("/developer", params).then((res) => {
    if (res.success) {
      return res.Item;
    }
    return null;
  });
};

// profile page
const addProfile = (data) => {
  const {
    ProfileId,
    Scope,
    Stage,
    ProfileName,
    Description,
    CreateDate,
    Permission,
    Host,
    MES,
  } = data;

  const params = {
    operation: "createProfile",
    tableName: "DevPortalClientProfile",
    payload: {
      Item: {
        ProfileId,
        Scope,
        Stage,
        ProfileName,
        Description,
        CreateDate,
        Permission,
      },
    },
  };
  if (MES === "MES16") {
    Object.assign(params.payload.Item, { MES, Host });
  }
  return getApiGatewayClient("/admin/developer", params);
};

const upateProfile = (data) => {
  const { ProfileId, Scope, Stage, ProfileName, Description, MES, Host } = data;
  let params = {
    operation: "updateProfile",
    tableName: "DevPortalClientProfile",
    payload: {
      Key: {
        ProfileId,
      },
      AttributeUpdates: {
        Scope: {
          Action: "PUT",
          Value: Scope,
        },
        Stage: {
          Action: "PUT",
          Value: Stage,
        },
        ProfileName: {
          Action: "PUT",
          Value: ProfileName,
        },
        Description: {
          Action: "PUT",
          Value: Description,
        },
      },
    },
  };
  if (MES === "MES16") {
    Object.assign(params.payload.AttributeUpdates, {
      Host: { Action: "PUT", Value: Host },
    });
  }
  return getApiGatewayClient("/admin/developer", params);
};

const deleteProfile = (data) => {
  const params = {
    operation: "deleteProfile",
    tableName: "DevPortalClientProfile",
    payload: {
      Key: {
        ProfileId: data.ProfileId,
        MES: data.MES,
      },
    },
  };
  return getApiGatewayClient("/admin/developer", params);
};

const updatePermission = (data) => {
  const { ProfileId, Scope, Stage, ProfileName, checkedL3Items, Host, MES } = data;
  const params = {
    operation: "updateProfile",
    tableName: "DevPortalClientProfile",
    payload: {
      Key: {
        ProfileId,
      },
      AttributeUpdates: {
        Scope: {
          Action: "PUT",
          Value: Scope,
        },
        Stage: {
          Action: "PUT",
          Value: Stage,
        },
        ProfileName: {
          Action: "PUT",
          Value: ProfileName,
        },
        Permission: {
          Action: "PUT",
          Value: checkedL3Items,
        },
      },
    },
  };
  if (MES === "MES16") {
    Object.assign(params.payload.AttributeUpdates, {
      Host: { Action: "PUT", Value: Host },
    });
  }
  return getApiGatewayClient("/admin/developer", params);
};

const getProfileDetail = async (data) => {
  const params = {
    operation: "read",
    tableName: "DevPortalClientProfile",
    payload: {
      Key: {
        ProfileId: data.ProfileId,
      },
    },
  };
  return getApiGatewayClient("/admin/developer", params).then((res) => {
    if (res.success) {
      const detail = res.Item;
      if (detail && detail.ProfileId) {
        return detail;
      }
      return {};
    }
    return null;
  });
};

const validateAppExists = () => {
  const params = {
    operation: "validate",
    tableName: "DevPortalClientApp",
    payload: {},
  };
  return getApiGatewayClient("/developer", params);
};

const getMES16ApiColor = async (host) => {
  return fetch(`https://${host}/api/color`, { mode: "cors" })
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
      return {};
    })
    .catch(() => {
      return {};
    });
};

const geApiGatewayApiColor = async (envide) => {
  return Promise.allSettled([
    fetch(`/42QConfig/MES16-${envide}-oauth-api.conf`).then((res) =>
      res.json()
    ),
    fetch(`/42QConfig/MES16-${envide}-erp-api.conf`).then((res) => res.json()),
  ]).then((res) => {
      let data = {
        oauthApi: "",
        erpApi: "",
      };
    const [oauthRes, erpRes] = res;
    if (
      oauthRes &&
      oauthRes.value &&
      oauthRes.value.active &&
      (oauthRes.value.active === "green" || oauthRes.value.active === "blue")
    ) {
      data.oauthApi = oauthRes.value.active;
    }
    if (
      erpRes &&
      erpRes.value &&
      erpRes.value.active &&
      (oauthRes.value.active === "green" || oauthRes.value.active === "blue")
    ) {
      data.erpApi = erpRes.value.active;
    }
    return data;
  });
};

const getMES15ApiColor = async (envide) => {
  return fetch(`/42QConfig/${envide}-color.conf`)
    .then((res) => res.json())
    .catch(() => Promise.resolve({ active: "" }));
};

const getMES15Host = async (envide) => {
  return fetch(`/42QConfig/${envide}-hosts.conf`)
    .then((res) => res.json())
    .catch(() => Promise.resolve({}));
};

const getEnvide = async () => {
  return fetch(`/42QConfig/envide.conf`)
    .then((res) => res.json())
    .catch(() => {
      return ENVIDE;
    });
};
export {
  getHostList,
  getMES16HostList,
  addHost,
  updateHost,
  deleteHost,
  getProfileList,
  getAppDetail,
  addApp,
  updateApp,
  deleteApp,
  getClientSecret,
  validateAttachedHost,
  getAppHostList,
  addAppHost,
  updateAppHost,
  deleteAppHost,
  updateAppProfile,
  getTargetList,
  updateTarget,
  getApiList,
  getUserClientSecret,
  getUserAppDetail,
  addProfile,
  upateProfile,
  deleteProfile,
  updatePermission,
  getProfileDetail,
  validateAppExists,
  getMES16AppHostList,
  getMES15ApiColor,
  getMES16ApiColor,
  getMES15Host,
  getEnvide,
  getApiKeyValue,
  geApiGatewayApiColor,
};
